(() => {
  const arrLabels = {
    en: { page: 'Page', prev: 'Previous', next: 'Next', pages: 'Article pages' },
    de: { page: 'Seite', prev: 'Zurück', next: 'Weiter', pages: 'Artikelseiten' },
    fr: { page: 'Page', prev: 'Précédent', next: 'Suivant', pages: 'Pages d’articles' }
  };
  const objText = arrLabels[(document.documentElement.lang || 'en').slice(0, 2)] || arrLabels.en;
  const INT_PAGE_SIZE = 12;
  function initialiseDispatch(objRoot) {
    if (objRoot.dataset.ready) return;
    objRoot.dataset.ready = 'true';
    const arrArticles = Array.from(objRoot.querySelectorAll('[data-article]'));
    const arrButtons = Array.from(objRoot.querySelectorAll('[data-topic]'));
    const objSearch = objRoot.querySelector('[data-search]');
    const objMore = objRoot.querySelector('[data-more]');
    const objCount = objRoot.querySelector('[data-count]');
    const objEmpty = objRoot.querySelector('[data-empty]');
    if (!objSearch || !objMore || !objCount || !objEmpty) return;
    const objPager = document.createElement('nav');
    objPager.className = 'ld-pager ld-mono';
    objPager.setAttribute('aria-label', objText.pages);
    objMore.parentNode.appendChild(objPager);
    objMore.hidden = true;
    let strTopic = 'all';
    let intPage = Math.max(1, parseInt(new URLSearchParams(location.search).get('pg'), 10) || 1);
    function renderPager(intPages) {
      objPager.textContent = '';
      objPager.hidden = intPages <= 1;
      if (intPages <= 1) return;
      const addButton = (strLabel, intTarget, boolCurrent, boolDisabled) => {
        const objButton = document.createElement('button');
        objButton.type = 'button';
        objButton.textContent = strLabel;
        if (boolCurrent) { objButton.setAttribute('aria-current', 'page'); }
        else { objButton.setAttribute('aria-label', `${objText.page} ${intTarget}`); }
        objButton.disabled = !!boolDisabled;
        objButton.addEventListener('click', () => { intPage = intTarget; updateArticles(true); });
        objPager.appendChild(objButton);
      };
      addButton('← ' + objText.prev, intPage - 1, false, intPage === 1);
      for (let intItem = 1; intItem <= intPages; intItem++) {
        if (intItem === 1 || intItem === intPages || Math.abs(intItem - intPage) <= 1) addButton(String(intItem), intItem, intItem === intPage, false);
        else if (Math.abs(intItem - intPage) === 2) { const objDots = document.createElement('span'); objDots.textContent = '…'; objPager.appendChild(objDots); }
      }
      addButton(objText.next + ' →', intPage + 1, false, intPage === intPages);
    }
    function updateArticles(boolMoved) {
      const strQuery = objSearch.value.trim().toLocaleLowerCase();
      const arrMatches = arrArticles.filter((objArticle) => (strTopic === 'all' || objArticle.dataset.category === strTopic)
        && objArticle.textContent.toLocaleLowerCase().includes(strQuery));
      const intPages = Math.max(1, Math.ceil(arrMatches.length / INT_PAGE_SIZE));
      intPage = Math.min(intPage, intPages);
      const arrShown = new Set(arrMatches.slice((intPage - 1) * INT_PAGE_SIZE, intPage * INT_PAGE_SIZE));
      arrArticles.forEach((objArticle) => { objArticle.hidden = !arrShown.has(objArticle); });
      objCount.textContent = `${arrMatches.length} article${arrMatches.length > 1 ? 's' : ''}`;
      objEmpty.hidden = arrMatches.length !== 0;
      renderPager(intPages);
      const objUrl = new URL(location.href);
      if (intPage > 1) objUrl.searchParams.set('pg', String(intPage)); else objUrl.searchParams.delete('pg');
      history.replaceState(null, '', objUrl);
      if (boolMoved) {
        const objFirst = arrArticles.find((objArticle) => !objArticle.hidden);
        objRoot.querySelector('.ld-grid')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (objFirst) objFirst.querySelector('h3 a')?.focus({ preventScroll: true });
      }
    }
    arrButtons.forEach((objButton) => objButton.addEventListener('click', () => {
      strTopic = objButton.dataset.topic;
      intPage = 1;
      arrButtons.forEach((objItem) => objItem.setAttribute('aria-pressed', String(objItem === objButton)));
      updateArticles();
    }));
    objSearch.addEventListener('input', () => { intPage = 1; updateArticles(); });
    objRoot.querySelector('[data-tools]').hidden = false;
    updateArticles();
  }
  document.querySelectorAll('[data-dispatch-blog]').forEach(initialiseDispatch);
  document.addEventListener('shopify:section:load', (objEvent) => {
    objEvent.target.querySelectorAll('[data-dispatch-blog]').forEach(initialiseDispatch);
  });
})();
